import React, { useState } from 'react'
import * as R from "ramda"
import { v4 } from 'uuid'
import LinkComponent from '../components/LinkComponent'
import { FaCheck } from "react-icons/fa";
import { Link } from 'gatsby';


const AmenitiesList = ({ amenitiesTitle, amenities, locale, linkObject }) => {
  const [isAmenitiesActive, setAmenitiesActiveStatus] = useState(false);
  const toggleAmenities = () => setAmenitiesActiveStatus(!isAmenitiesActive);

  const renderSplitAmenities = (splitAmenities) => {
    if (isAmenitiesActive) {
      return splitAmenities;
    }
    return splitAmenities[0];
  };

  const renderAmenitiesButtonText = () => {
    if (!isAmenitiesActive) {
      return "See all Amenities"
    }
    return "See less"
  }

  const renderLinkButton = () => {
    if (!linkObject || linkObject.title === "") {
      return null;
    }
    return (
      <div className="amenities-btn-wrapper">
        <LinkComponent linkObject={linkObject}>
          <button className="btn-secondary ">{linkObject.title}</button>
        </LinkComponent>
      </div>
    )
  }

  let amenitiesArray = !!amenities ? amenities : [];

  if (amenitiesArray.length) {
    const mapAmenities = (amenities) => {
      if (!!amenities && !!amenities.length) {
        return amenities.map((amenity) => (
          <div key={v4()}>
            <div className="amenities-item" key={amenity}><FaCheck /> {amenity}</div>
          </div>
        ));
      }
      return null;
    };

    const mappedAmenities = mapAmenities(amenities);
    const splitAmenities = mappedAmenities.length > 10 ? R.splitAt(10, mappedAmenities) : [mappedAmenities];
    if (splitAmenities.length > 1) {
      return (
        <div className="amenities-list-section">
          <div className="container content">
            <h2 className="title">{ amenitiesTitle || "Amenities" }</h2>
            <div>
              {renderSplitAmenities(splitAmenities)}
            </div>
            <button className="btn-secondary" onClick={toggleAmenities}>{renderAmenitiesButtonText()}</button>
          </div>
          { renderLinkButton() }
        </div>
      );
    }
    return (
      <div className="amenities-list-section">
        <div className="container content">
          <h2 className="title">{ amenitiesTitle || "Amenities" }</h2>
          {mappedAmenities}

          { renderLinkButton() }
        </div>
      </div>
    )
  }
  return null;
}

export default AmenitiesList;